// Pure vendor-group transforms for the portal editor — mirrors the desktop's
// apps/desktop/src/renderer/vendor-groups.ts semantics (that module isn't
// importable across apps, so the minimal logic is mirrored here and unit-tested).
// Every transform returns a NEW array; inputs are never mutated.
import type { VendorGroup } from "./api";

function newId(): string {
  const c = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  return `g-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}

/** Build a fresh, empty group with the given (trimmed) name. */
export function makeGroup(name: string): VendorGroup {
  return { id: newId(), name: name.trim(), supplierIds: [] };
}

/** Prepend a fresh group (newest on top). */
export function addGroup(groups: VendorGroup[], group: VendorGroup): VendorGroup[] {
  return [group, ...groups];
}

/** Rename one group by id. */
export function renameGroup(groups: VendorGroup[], id: string, name: string): VendorGroup[] {
  return groups.map((g) => (g.id === id ? { ...g, name } : g));
}

/** Drop one group by id. */
export function deleteGroup(groups: VendorGroup[], id: string): VendorGroup[] {
  return groups.filter((g) => g.id !== id);
}

/** Toggle a supplier's membership in one group. */
export function toggleMember(
  groups: VendorGroup[],
  id: string,
  supplierId: string,
): VendorGroup[] {
  return groups.map((g) => {
    if (g.id !== id) return g;
    const has = g.supplierIds.includes(supplierId);
    return {
      ...g,
      supplierIds: has
        ? g.supplierIds.filter((s) => s !== supplierId)
        : [...g.supplierIds, supplierId],
    };
  });
}
